export default "__VITE_ASSET__ByWs5UHq__"